import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { HeaderCartographieComponent } from '../components/header-cartographie/header-cartographie.component';

@Component({
  selector: 'app-croisement-layout',
  imports: [RouterModule, HeaderCartographieComponent],
  templateUrl: './croisement-layout.component.html',
})
export class CroisementLayoutComponent {}
